import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '@mui/icons-material';
import locales from '../locales.json';
import { useLang } from "../context/LangContext";

function EmailValidation() {
  const { lang } = useLang();
  const { signup_page } = locales;

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '0', // Enlève la contrainte de hauteur
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', // Commence en haut
        py: { xs: 4, md: 6 }, // Padding vertical raisonnable
        px: { xs: 1, sm: 2, md: 0 },
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          padding: { xs: '20px', sm: '32px' },
          borderRadius: '16px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          textAlign: 'center',
          width: '100%',
          maxWidth: '400px',
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60, marginBottom: '16px' }} />
        <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.3rem', md: '1.5rem' } }}>
          {signup_page.email_validation_title?.[lang] || "Confirmation de l'inscription"}
        </Typography>
        <Typography variant="body1" sx={{ marginTop: '8px', fontSize: { xs: '1rem', md: '1.1rem' } }}>
          {signup_page.email_validation_message?.[lang] ||
            "Un email de confirmation a été envoyé à votre adresse email.\nVeuillez cliquer sur le lien contenu dans cet email pour activer votre compte."}
        </Typography>
      </Box>
    </Container>
  );
}

export default EmailValidation;